import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import LoadingFallback from "./components/LoadingFallback";
import PublicRoute from './components/PublicRoute';
import PrivateRoute from './components/PrivateRoute';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';

const Signup = lazy(() => import("./pages/auth/Signup"));
const AccountSetup = lazy(() => import("./pages/auth/AccountSetup"));
const Login = lazy(() => import("./pages/auth/Login"));
const PasswordReset = lazy(() => import("./pages/auth/PasswordReset"));
const Profile = lazy(() => import("./pages/auth/Profile"));
const ProfileEdit = lazy(() => import("./pages/auth/ProfileEdit"));
const Reauthenticate = lazy(() => import("./pages/auth/Reauthenticate"));

const Home = lazy(() => import("./pages/Home"));
const ExerciseCollectionPage = lazy(() => import("./pages/ExerciseCollectionPage"));
const PostBoard = lazy(() => import("./pages/PostBoard"));
const Post = lazy(() => import("./pages/Post"));

const PersonalizedPracticeWrapper = lazy(() => import("./pages/exercise/PersonalizedPracticeWrapper"));
const RegularMCQ = lazy(() => import("./pages/exercise/RegularMCQ"));
const RegularWordform = lazy(() => import("./pages/exercise/RegularWordform"));
const RegularTrios = lazy(() => import("./pages/exercise/RegularTrios"));
const TwoPanelExercise = lazy(() => import("./pages/exercise/TwoPanelExercise"));

function App() {
    return (
        <LanguageProvider>
            <AuthProvider>
                <Router>
                    <div className="min-h-screen grid grid-rows-[auto_1fr_auto] grid-cols-1 font-raleway text-neutral-600">
                        <Header />
                        <Suspense fallback={<LoadingFallback/>}>
                            <Routes>
                                <Route path="/" exact element={<Home/>}/>
                                <Route path="/beginner" element={<ExerciseCollectionPage boardNameVN="Cơ bản" boardNameEN="Beginner" boardID="beginner"/>}/>
                                <Route path="/ielts" element={<ExerciseCollectionPage boardNameVN="IELTS" boardNameEN="IELTS" boardID="ielts"/>}/>
                                <Route path="/advanced" element={<ExerciseCollectionPage boardNameVN="Nâng cao" boardNameEN="Advanced" boardID="advanced"/>}/>
                                <Route path="/listening" element={<ExerciseCollectionPage boardNameVN="Nghe thực tế" boardNameEN="Authentic Listening" boardID="listening"/>}/>
                                <Route path="/personalized" element={<PersonalizedPracticeWrapper/>}/>
                                <Route path="/mcq" element={<RegularMCQ/>} />
                                <Route path="/wf" element={<RegularWordform/>}/>
                                <Route path="/trio" element={<RegularTrios/>}/>
                                <Route path="/gap" element={<TwoPanelExercise answerType="blank" titleVN="Nghe điền từ" titleEN="Gapped Listening"/>}/>
                                <Route path="/tfng" element={<TwoPanelExercise answerType="tfng" titleVN="Nghe T/F/NG" titleEN="T/F/NG Listening"/>}/>
                                <Route path="/posts" element={<PostBoard/>} />
                                <Route path="/post" element={<Post/>} />
                                <Route path="/signup" element={<Signup/>}/>
                                <Route path="/setup-profile" element={
                                    <PrivateRoute>
                                        <AccountSetup/>
                                    </PrivateRoute>
                                }/>
                                <Route path="/login" element={
                                    <PublicRoute>
                                        <Login/>
                                    </PublicRoute>
                                }/>
                                <Route path="/forgot-password" element={
                                    <PublicRoute>
                                        <PasswordReset/>
                                    </PublicRoute>
                                }/>
                                <Route path="/profile" element={
                                    <PrivateRoute>
                                        <Profile/>
                                    </PrivateRoute>
                                }/>
                                <Route path="/edit-profile" element={
                                    <PrivateRoute>
                                        <ProfileEdit/>
                                    </PrivateRoute>
                                }/>
                                <Route path="/reauthenticate" element={
                                    <PrivateRoute>
                                        <Reauthenticate/>
                                    </PrivateRoute>
                                }/>
                            </Routes>
                        </Suspense>
                        <Footer />
                    </div>
                </Router>
            </AuthProvider>
        </LanguageProvider>
    );
}

export default App;
